import { styled } from "styled-components";
import { colors, typography, border } from "@joinTrilo/ui/tokens";
import Card from "@joinTrilo/ui/atoms/Card";

export const StyledCamelLog = styled(Card)`
    padding: 1.2rem 1.6rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1.6rem;
    width: 100%;
`;

export const StyledLogRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
`;
export const StyledLogLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.8rem;
`;
export const StyledLogRight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;
export const StyledLogVis = styled.div`
    width: 3.5rem;
    height: 3.5rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StyledLogLogo = styled.img`
    border-radius: ${border.radius.circle};
    overflow: hidden;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

export const StyledLogLogoLoader = styled.div`
    border-radius: ${border.radius.circle};
    background-color: ${colors.darkGrey};
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

export const StyledDirectionArrow = styled.img`
    position: absolute;
    bottom: 0;
    right: 0;
`;
export const StyledLogBrief = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
`;
export const StyledLogName = styled.div`
    font: ${typography.fonts.subHeadingSmall};
    line-height: 1.9rem;
`;
export const StyledLogNote = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.deepGrey};
    line-height: 1.6rem;
`;
export const StyledLogQuestion = styled.div`
    font: ${typography.fonts.smallSemiBold};
    color: ${colors.darkTurquoise};
    line-height: 1.6rem;
`;
export const StyledLogAmount = styled.div`
    font: ${typography.fonts.subHeadingSmall};
`;
